import HiddenInput from "@/components/form/components/HiddenInput";
import AntIcon from "@/components/icons/AntIcon";
import { setErrorsToForm } from "@/utils/formUtils";
import { validations } from "@/utils/validationUtils";
import { Button, Checkbox, Col, Form, Row } from "antd";
import { useTranslation } from "react-i18next";
import { generatePath, useNavigate } from "react-router";
import { useCreateCalcSettings } from "../../../../../common/api/queries/calcSettings";
import { rowGutter } from "../../../../../common/constants";
import InstitutionSelect from "../../../../enumerations/components/form/InstitutionSelect";
import { InstitutionType } from "../../../../institution/enums";
import { CalcType } from "../../../enums";
import { ADMIN_CALC_ROUTE_PATHS } from "../../paths";
import { UpdateCalcSettings } from "../../types";
import { CalcSettingsPaymentDetailsPart } from "./parts/CalcSettingsPaymentDetailsPart";
import CalcSettingsProductsPart from "./parts/CalcSettingsProductsPart";

const colSpan = 5;

type Props = {
  calcType: CalcType;
};

export const CreateCalcSettingsForm = ({ calcType }: Props) => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [form] = Form.useForm<UpdateCalcSettings>();

  const createCalcSettings = useCreateCalcSettings();

  const handleFormFinish = (values: UpdateCalcSettings) => {
    createCalcSettings.mutate(values, {
      onSuccess: (data) => navigate(generatePath(ADMIN_CALC_ROUTE_PATHS.detail.to, { id: data.id }), { replace: true }),
      onError: (error) => setErrorsToForm(form, "calc.settings.attrs", error.violations),
    });
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleFormFinish} name="calcSettingsForm">
      <HiddenInput name="type" initialValue={calcType} />

      <Row gutter={rowGutter}>
        <Col span={colSpan}>
          <InstitutionSelect
            formItemProps={{
              name: "institutionId",
              label: t("common.insuranceInstitution"),
              rules: [validations.notNull],
            }}
            optionsProps={{ filterType: InstitutionType.INSURANCE_COMPANY }}
          />
        </Col>

        <Col span={colSpan}>
          <Form.Item
            name="enabled"
            className="form-item-without-label"
            valuePropName="checked"
            rules={[validations.none]}
            initialValue={false}
          >
            <Checkbox>{t("calc.settings.attrs.enabled")}</Checkbox>
          </Form.Item>
        </Col>
      </Row>

      <CalcSettingsProductsPart calcType={calcType} />

      <CalcSettingsPaymentDetailsPart />

      <div className="margin-top-medium">
        <Button type="primary" htmlType="submit" className="margin-right-tiny" icon={<AntIcon type="save" />}>
          {t("common.save")}
        </Button>
      </div>
    </Form>
  );
};
